import { Component, Input, OnInit, ViewChild, Injector } from "@angular/core";
import { Router, RouterLink } from "@angular/router";

import { UserblockService } from "../sidebar/userblock/userblock.service";
import { SettingsService } from "../../core/settings/settings.service";
import { MenuService } from "../../core/menu/menu.service";

import { TranslatePipe } from "@ngx-translate/core";
import { TranslatorService } from "src/app/core/translator/translator.service";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { FormsModule } from "@angular/forms";
import { NgFor, NgIf } from "@angular/common";
import {
  BsDropdownDirective,
  BsDropdownToggleDirective,
  BsDropdownMenuDirective,
} from "ngx-bootstrap/dropdown";
import { NavsearchComponent } from "./navsearch/navsearch.component";
import { CartService } from "src/app/core/shop/cart.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  imports: [
    FormsModule,
    NgFor,
    BsDropdownDirective,
    BsDropdownToggleDirective,
    BsDropdownMenuDirective,
    RouterLink,
    NavsearchComponent,
    TranslatePipe,
    NgIf,
  ],
})
export class HeaderComponent implements OnInit {
  @Input() showSidebarToggle = true;
  navCollapsed = true; // for horizontal layout
  menuItems = []; // for horizontal layout
  router: Router;
  currentTheme: any;
  selectedLanguage: string;
  isNavSearchVisible: boolean;
  @ViewChild("fsbutton", { static: true }) fsbutton; // the fullscreen button
  cartItemCount = 0;
  constructor(
    public menu: MenuService,
    public userblockService: UserblockService,
    public settings: SettingsService,
    public injector: Injector,
    public oidcSecurityService: OidcSecurityService,
    public translator: TranslatorService,
    public cartService: CartService,
  ) {
    // show only a few items on demo
    this.menuItems = menu.getMenu().slice(0, 4); // for horizontal layout
    // this.selectedLanguage = this.translator.selectedLanguage.getValue();
  }

  ngOnInit() {
    this.isNavSearchVisible = false;

    const ua = window.navigator.userAgent;
    // eslint-disable-next-line no-useless-escape
    if (ua.indexOf("MSIE ") > 0 || !!ua.match(/Trident.*rv\:11\./)) {
      // Not supported under IE
      this.fsbutton.nativeElement.style.display = "none";
    }

    this.router = this.injector.get(Router);

    // Autoclose navbar on mobile when route change
    this.router.events.subscribe((val) => {
      // scroll view to top
      window.scrollTo(0, 0);
      // close collapse menu
      this.navCollapsed = true;
    });
    this.toggleLang();
    this.cartService.cartItems.subscribe((items) => {
      this.cartItemCount = items.reduce((sum, item) => sum + item.quantity, 0);
    });
  }

  toggleUserBlock(event) {
    event.preventDefault();
    this.userblockService.toggleVisibility();
  }

  openNavSearch(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setNavSearchVisible(true);
  }

  setNavSearchVisible(stat: boolean) {
    //
    this.isNavSearchVisible = stat;
  }

  getNavSearchVisible() {
    return this.isNavSearchVisible;
  }

  toggleOffsidebar() {
    this.settings.toggleLayoutSetting("offsidebarOpen");
  }

  toggleCollapsedSideabar() {
    if (window.innerWidth < 768) {
      const isOpen = this.settings.getLayoutSetting("asideToggled");
      this.settings.setLayoutSetting("asideToggled", !isOpen);
      this.settings.setLayoutSetting("isCollapsed", isOpen);
    } else {
      const isCollapsed = this.settings.getLayoutSetting("isCollapsed");
      this.settings.setLayoutSetting("isCollapsed", !isCollapsed);
    }
  }

  isCollapsedText() {
    return this.settings.getLayoutSetting("isCollapsedText");
  }

  toggleFullScreen(event) {
    const doc = document.documentElement;
    const el = this.fsbutton.nativeElement.firstElementChild;
    if (!document.fullscreenElement) {
      doc.requestFullscreen().catch((err) => console.log(err));
      el.className = "fa fa-compress";
    } else {
      document.exitFullscreen().catch((err) => console.log(err));
      el.className = "fa fa-expand";
    }
  }

  getLangs() {
    return this.translator.getAvailableLanguages();
  }

  setLang(value) {
    this.translator.useLanguage(value);
  }

  toggleLang() {
    this.translator.selectedLanguage.subscribe((r) => {
      this.selectedLanguage = r;
    });
  }

  openCart() {
    this.router.navigate(["/shop/cart"]);
  }

  logout() {
    this.oidcSecurityService.logoff().subscribe(() => {
      console.log("Logged out.");
    });
  }
}
